import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initTheme } from './theme';
import { detectLanguage, setLanguage } from './i18n';

// Mavzuni birinchi renderdan oldin qo'llaymiz (index.html dagi skript bilan
// birga ishlaydi — u erta, bu esa Telegram SDK yuklangandan keyin).
initTheme();

/*
 * Til birinchi renderdan OLDIN oʻrnatiladi.
 *
 * `t()` — oddiy funksiya, React holati emas: shuning uchun til
 * almashtirilganda sahifa qayta yuklanadi (qarang ProfilePage).
 * Bu ataylab — shunda `t()` ni komponentdan tashqarida ham ishlatsa
 * boʻladi va har bir matn uchun hook talab qilinmaydi.
 */
setLanguage(detectLanguage());

/*
 * MANZILNI TOZALAYMIZ.
 *
 * Ilova HashRouter'da ishlaydi, yaʼni yoʻnalish `#` dan keyin turadi.
 * Server esa ISTALGAN yoʻlga shu sahifani beradi (SPA fallback) —
 * natijada `/login#/profile` kabi manzil yopishib qoladi va shu
 * koʻrinishda saqlanib, ulashilib ketadi.
 *
 * `replaceState` — qayta yuklamaydi va tarixga yangi yozuv qoʻshmaydi.
 * `/index.html` TEGILMAYDI: Mini App aynan shu manzildan ochiladi.
 */
{
  const routePath = window.location.pathname;
  if (routePath !== '/' && routePath !== '/index.html') {
    window.history.replaceState(
      null,
      '',
      '/' + window.location.search + window.location.hash,
    );
  }
}

// Save original URL data before HashRouter overwrites it
(window as any).__ORIGINAL_HASH__ = window.location.hash;
(window as any).__ORIGINAL_SEARCH__ = window.location.search;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
